import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Fragment, useEffect, useMemo, useState } from "react";
import FileAttach from "../../../../../../images/BrowseFiles.svg";
import DownArrow from "../../../../../../images/DownArrow.svg";
import TotalStudents from "../../../../../../images/TotalMale.svg";
import ReadyToImport from "../../../../../../images/Present.svg";
import ContainsError from "../../../../../../images/Absent.svg";
import ExcelJS from "exceljs";
import Info from "../../../../../../images/Information.svg";

import Close from "../../../../../../images/Close.svg";
import ReactModal from "react-modal";

import { useMutation } from "@apollo/client";

import * as XLSX from "xlsx";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { emptyMessage } from "../../../../../../utils/constants";
import useUrlParams from "../../../../../../customHooks/useUrlParams";

import {
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../../../utils/Enum.types";
import { Title } from "../../../../../../stories/Title/Title";
import { CustomTooltip } from "../../../../../../styles/TooltipStyles";
import { Button } from "../../../../../../stories/Button/Button";
import { LoadingStyles } from "../../../../../../styles/ModalStyles";
import ExcelLoading from "../../../../../pages/ExcelLoading";
import MessageModal from "../../../../../../customComponents/MessageModal";

import { getDownloadUrl } from "../../../../../../utils/DownloadFile";

import {
  BulkAlterJunctionsMutation,
  ExportJunctions,
} from "./queries/mutations";
import Navbar from "../../../../../common/layout/Navbar";
import useLabels from "../../../../../../customHooks/useLabels";
import { useNavigate } from "react-router-dom";
import { removeCompleteSpace } from "../../../../../../utils/UtilFunctions";
import {
  BulkAlterAtsJunctionsResult,
  BulkAlterAtsJunctionsVar,
  ExportJunctionsData,
  ExportJunctionsVars,
} from "./queries/types";
import LoadingModal from "../../../../../pages/LoadingModal";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
  NavType: LicenseTypes;
}

const AlterJunctions = ({ setModalFlag, NavType, pageType }: Props) => {
  const [records, setRecords] = useState<any[]>([]);
  const { junctionLabel, subsidiaryLabel, subsidiarySiteLabel, companyLabel } =
    useLabels();

  const [message, setMessage] = useState(emptyMessage);
  const { customer_id } = useUrlParams();
  const [importModal, setImportModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);

  const { user_details } = useLoggedInUserDetails();

  const navigate = useNavigate();

  const [expanded, setExpanded] = useState(false);

  const [BulkAlterJunctions, { loading }] = useMutation<
    BulkAlterAtsJunctionsResult,
    BulkAlterAtsJunctionsVar
  >(BulkAlterJunctionsMutation, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });
  const [ExportJunctionsDetails, { loading: AddItemLoading }] = useMutation<
    ExportJunctionsData,
    ExportJunctionsVars
  >(ExportJunctions, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const displayFileName = (): void => {
    const inputElement = document.getElementById("input") as HTMLInputElement;
    const fileName = inputElement.value;
    const fileLabel = document.getElementById("file-name") as HTMLSpanElement;
    fileLabel.innerHTML = fileName.split("\\").pop()!;
  };
  const handleExport = async () => {
    try {
      if (customer_id) {
        const { data, errors } = await ExportJunctionsDetails({
          variables: {
            customerID: customer_id,
          },
        });

        if (data && data.ExportJunctions) {
          const res = await getDownloadUrl(data.ExportJunctions, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        } else {
          setMessage({
            flag: true,
            message: "Failed downloading file",
            operation: Operation.NONE,
          });
        }

        if (errors && errors.length > 0) {
          setMessage({
            flag: true,
            message: errors[0].message,
            operation: Operation.NONE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };
  const totalRecords = useMemo(() => {
    return records.filter((record) => !record.errors).length;
  }, [records]);
  const downloadExcelContainsError = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("ErrorData");
    worksheet1.views = [{ state: "frozen", xSplit: 1, ySplit: 1 }];
    if (records.length === 0) {
      console.warn("No data available to create the Excel file.");
      return;
    }

    const errorColumns = ["errors"];
    const headers = Object.keys(records[0]).filter(
      (header) =>
        !["isChecked", "isValidated", "isValidatedAndError", "id"].includes(
          header,
        ),
    );

    errorColumns.forEach((col) => {
      if (!headers.includes(col)) {
        headers.push(col);
      }
    });
    worksheet1.columns = headers.map((header) => ({
      header,
      key: header,
      width: 20,
    }));

    const headerRow = worksheet1.getRow(1);
    headerRow.height = 25;
    headerRow.font = { name: "Arial", size: 12, bold: true };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFE0B2" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    records
      .filter((record) => record?.errors)
      .forEach((entry, rowIndex) => {
        const row = worksheet1.getRow(rowIndex + 2);
        headers.forEach((header, colIndex) => {
          const cell = row.getCell(colIndex + 1);
          cell.value = entry[header];
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "StudentInfo.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  const handleAddSubsidiarySite = async () => {
    setSuccessCount(0);
    setErrorCount(0);
    setImportModal(true);

    for (const record of records.filter((record) => !record.errors)) {
      try {
        console.log(
          subsidiarySiteLabel,
          record[`${removeCompleteSpace(subsidiarySiteLabel)}`],
        );

        await BulkAlterJunctions({
          variables: {
            customerID: customer_id!,
            user_details,
            junctionID: record[`ID`] ? record[`ID`] : 0,
            input: {
              subsidiaryName: record[`${removeCompleteSpace(subsidiaryLabel)}`],
              siteName: record[`${removeCompleteSpace(subsidiarySiteLabel)}`],
              address: record.Address ? record.Address : undefined,
              place: record.Place ? record.Place : undefined,
              state: record.State ? record.State : undefined,
              pin: record.Pin ? record.Pin : undefined,
              alias: record.Alias ? record.Alias : undefined,
              jType: record.Type ? record.Type : undefined,
              arms: record.Arms ? record.Arms : undefined,
              country: record.Country ? record.Country : undefined,
              latitude: record.Latitude ? record.Latitude : undefined,
              longitude: record.Longitude ? record.Longitude : undefined,
              code: record.Code ? record.Code : undefined,
              name: record.Name ? record.Name : undefined,
              poles: record.Poles ? record.Poles : undefined,
              companyName: record[`${removeCompleteSpace(companyLabel)}`],
              remarks: record.Remarks ? record.Remarks : undefined,
              junctionStatus: record.JunctionStatus
                ? record.JunctionStatus
                : undefined,
              priority: record.Priority ? record.Priority : undefined,
            },
          },
        }).then(({ data }) => {
          if (data) {
            setSuccessCount((prev) => prev + 1);
          }
        });
      } catch (error) {
        console.error(error);
        setErrorCount((prev) => prev + 1);
      }
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag(false);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };
  const site_schema = {
    [`ID`]: {
      Headers: `${junctionLabel}ID`,
      key: `ID`,
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    [`${removeCompleteSpace(companyLabel)}`]: {
      Headers: `${companyLabel}`,
      key: `${removeCompleteSpace(companyLabel)}`,
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    [`${removeCompleteSpace(subsidiaryLabel)}`]: {
      Headers: `${subsidiaryLabel}`,
      key: `${removeCompleteSpace(subsidiaryLabel)}`,
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    [`${removeCompleteSpace(subsidiarySiteLabel)}`]: {
      Headers: `${subsidiarySiteLabel}`,
      key: `${removeCompleteSpace(subsidiarySiteLabel)}`,
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    Name: {
      Headers: "Name",
      key: "name",
      width: 50,
      required: true,
      use_in_sheet: true,
    },

    Code: {
      Headers: "Code",
      key: "code",
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    Address: {
      Headers: "Address",
      key: "address",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Place: {
      Headers: "Place",
      key: "place",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    State: {
      Headers: "State",
      key: "state",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Pin: {
      Headers: "PIN Code",
      key: "pin",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Country: {
      Headers: "Country",
      key: "country",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Alias: {
      Headers: "Alias",
      key: "alias",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    JunctionStatus: {
      Headers: "JunctionStatus",
      key: "junctionStatus",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Priority: {
      Headers: "Priority",
      key: "priority",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    JType: {
      Headers: "JType",
      key: "jType",
      width: 50,
      required: true,
      use_in_sheet: true,
    },
    Arms: {
      Headers: "Arms",
      key: "arms",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Poles: {
      Headers: "Poles",
      key: "poles",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Latitude: {
      Headers: "Latitude",
      key: "latitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    Longitude: {
      Headers: "Longitude",
      key: "longitude",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
    remarks: {
      Headers: "Remarks",
      key: "remarks",
      width: 50,
      required: false,
      use_in_sheet: true,
    },
  };

  const processExcel = (data: any) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const firstSheet = workbook.SheetNames[0];
    const records = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet]);
    records.forEach((record: any) => {
      let errors: any = [];

      Object.keys(site_schema).forEach((key) => {
        // @ts-ignore
        let keySchema = site_schema[key];
        let keyValue = record[key];

        if (
          keySchema?.required &&
          (keyValue === null || keyValue === undefined)
        ) {
          let errorObj = {
            column: key,
            error: "Required",
          };
          errors.push(errorObj);
        }
      });

      if (errors.length > 0) {
        record.errors = errors;
      }
    });

    return records;
  };

  useEffect(() => {
    const input = document.getElementById("input") as HTMLInputElement;
    if (input) {
      input.addEventListener("change", () => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const res = processExcel(reader.result);
          setRecords(
            res.map((f: any, index: number) => {
              return {
                ...f,
                id: index + 1,
                isChecked: false,
                isValidated: false,
                isValidatedAndError: false,
              };
            }),
          );
        };
        reader.readAsBinaryString(input.files![0]);
      });
    }
  });

  const schemaKeys = Object.keys(site_schema);

  return (
    <>
      {pageType === PageFor.GENERAL ? (
        <>
          <Navbar NavType={NavType} />
          <Title>Alter {junctionLabel} Details</Title>
        </>
      ) : null}
      <div
        className={`import-excel-data${
          pageType === PageFor.GENERAL ? "" : "__modal"
        }`}
      >
        {" "}
        {pageType === PageFor.MODAL && (
          <div className="import-excel-data--title">
            <Title>Alter {junctionLabel} Details</Title>
            <img src={Close} alt="" onClick={() => setModalFlag(false)} />
          </div>
        )}
        <div className="row g-0 import-excel-data__blocks">
          <div className="col-6">
            <div className="import-excel-data__file-upload">
              <div className="import-excel-data__file-upload--file-name">
                <span id="file-name"></span>
              </div>
              <div className="import-excel-data__file-upload--browse">
                <label htmlFor="input">
                  <img src={FileAttach} alt="/" /> Choose Excel File
                </label>
                <input
                  id="input"
                  type="file"
                  name="file"
                  onChange={() => displayFileName()}
                  className="import-excel-data__file-upload--input"
                />
              </div>
            </div>
          </div>

          <div className="col import-excel-data__blocks--cards">
            <b>
              <img src={TotalStudents} alt="/" />
              Total {junctionLabel}
            </b>
            <span className="import-excel-data__blocks--cards--total-students">
              {records.length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            // onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ReadyToImport} alt="/" />
              Ready to Import
            </b>
            <span className="import-excel-data__blocks--cards--ready-to-import">
              {records.filter((record) => !record.errors).length}
            </span>
          </div>
          <div
            className="col import-excel-data__blocks--cards"
            onClick={() => setExpanded(!expanded)}
          >
            <b>
              <img src={ContainsError} alt="/" />
              Contains Error
            </b>
            <span className="import-excel-data__blocks--cards--contains-error">
              {records.filter((record) => record?.errors).length}
            </span>
          </div>
        </div>
        <div
          className={`import-excel-data__datablock${
            pageType === PageFor.MODAL ? "" : "--general"
          }`}
        >
          {records.length > 0 ? (
            <>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--records-count">
                  <span>
                    {records.filter((record) => !record.errors).length}
                  </span>
                  <b> Records Found to Import</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              <div className="import-excel-data__datablock--tableblock">
                <TableContainer className="import-excel-data__datablock--table">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell id="td-center">
                          {TableHeaders.SLNO}
                        </TableCell>
                        {schemaKeys
                          .filter((key) =>
                            records.some((record) => key in record),
                          )
                          .map((key, index) => (
                            <TableCell key={index}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {records
                        .filter((record) => !record?.errors)
                        .map((record, index) => (
                          <TableRow key={index}>
                            <TableCell id="td-center">{index + 1}</TableCell>
                            {schemaKeys
                              .filter((key) => key in record)
                              .map((key, colIndex) => (
                                <Fragment key={colIndex}>
                                  <TableCell key={colIndex}>
                                    {record[key]}
                                  </TableCell>
                                </Fragment>
                              ))}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div
                className="import-excel-data__datablock--title"
                onClick={() => setExpanded(!expanded)}
              >
                <div className="import-excel-data__datablock--errors-count">
                  <span>{records.filter((d) => d?.errors).length}</span>
                  <b>Records Which Contains error(s)</b>
                </div>
                <img src={DownArrow} alt="/" />
              </div>
              {expanded && (
                <div className="import-excel-data__datablock--tableblock">
                  <TableContainer className="import-excel-data__datablock--table">
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell id="td-center">
                            {TableHeaders.SLNO}
                          </TableCell>
                          {schemaKeys
                            .filter((key) =>
                              records.some((record) => key in record),
                            )
                            .map((key, index) => (
                              <TableCell key={index}>{key}</TableCell>
                            ))}
                          <TableCell id="td-center">Error Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {records
                          .filter((record) => record?.errors)
                          .map((record, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell id="td-center">
                                  {index + 1}
                                </TableCell>
                                {schemaKeys
                                  .filter((key) => key in record)
                                  .map((key, colIndex) => (
                                    <Fragment key={colIndex}>
                                      <TableCell>{record[key]}</TableCell>
                                    </Fragment>
                                  ))}

                                <TableCell className="import-excel-data__datablock--error">
                                  <CustomTooltip
                                    title={
                                      <ul>
                                        {record?.errors
                                          ? record?.errors?.map(
                                              (error: any, index: number) => {
                                                return (
                                                  <li key={index}>
                                                    {index + 1})&nbsp;
                                                    {typeof error === "string"
                                                      ? error
                                                      : "Error message = " +
                                                        error.error +
                                                        ", column = " +
                                                        error.column}
                                                  </li>
                                                );
                                              },
                                            )
                                          : null}
                                      </ul>
                                    }
                                    arrow
                                    placement="bottom-start"
                                  >
                                    <div className="import-excel-data__datablock--tableblock--error-message">
                                      <span>Errors</span>
                                      <img src={Info} alt="/" />
                                    </div>
                                  </CustomTooltip>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </>
          ) : null}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              onClick={() => {
                handleAddSubsidiarySite();
              }}
              disabled={!records.length ? true : false}
              mode="excel"
            >
              Import
            </Button>

            <Button onClick={downloadExcelContainsError} mode="excel">
              Export error Data
            </Button>
            <Button
              mode={pageType === PageFor.GENERAL ? "back" : "cancel"}
              onClick={() => {
                if (pageType === PageFor.MODAL) {
                  setModalFlag(false);
                } else {
                  navigate(-1);
                }
              }}
            />
          </div>
          <div className="col-3 import-excel-data__button">
            <Button mode="excel" onClick={handleExport}>
              Export
            </Button>
          </div>
        </div>
      </div>

      <ReactModal
        shouldCloseOnOverlayClick={true}
        isOpen={importModal}
        style={LoadingStyles}
        ariaHideApp={false}
        onRequestClose={() => setImportModal(!importModal)}
      >
        <ExcelLoading
          total={totalRecords}
          success={successCount}
          errors={errorCount}
          loading={loading}
          setModalFlag={setImportModal}
        />
      </ReactModal>
      <LoadingModal flag={AddItemLoading} />
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
    </>
  );
};

export default AlterJunctions;
